/* eslint-disable  @typescript-eslint/no-floating-promises */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  react/jsx-no-bind */
/* eslint-disable  no-restricted-syntax  */
/* eslint-disable  no-lonely-if  */
/* eslint-disable  no-await-in-loop  */

import { Alert, Button, Checkbox, Col, Input, InputNumber, message, Radio, Row, Typography } from 'antd';
import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { find, get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse, Hint, Space } from '~/components';
import Form from '~/components/WizardForm';
import colors from '~/constants/colors';
import theme from '~/constants/theme';
import { useFieldMap, useGetServices } from '~/controllers/pricing';
import { ApplicationPayload } from '~/types/ApplicationPayload';
import { CustomPricing, ProductMap } from '~/types/CustomPricing';
import { ServicesKeys } from '~/types/Services';
import LongDescription from '~/components/views/ServicesView/LongDescription';
import ServiceCheckbox from '~/components/views/ServicesView/ServiceCheckbox';
import { Draft } from '~/types/Draft';
import DynamicForm from '~/components/WidgetREnder/DynamicForm';
import { useGetApplication, useSelectStep } from '~/controllers/wizard';
import { useGetDraft } from '~/controllers/draft';
import { useAmendment } from '~/controllers/amendment';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import buildNamePath from '~/utils/buildNamePath';
import HierarchyCheckBox from '~/components/views/ServicesView/HierarchyCheckBox';
import { setConfirmValue } from '~/slices/state';
import { capitalizeWords } from '~/utils/validateCharacters';
import DropDown from '~/components/inputs/DropDown';
import { useHandbookDefault } from '~/components/views/ServicesView/utils';
import { getStagePayload } from '~/utils/getStagePayload';

type PanelErrorType = Record<ServicesKeys, boolean>;
const initialPanelErrorState: PanelErrorType = {
  nGeniusPos: false,
  eCommerce: false,
  nGeniusGo: false,
  CORPORATE_EXECUTIVE_CARD: false,
  DIGITAL_BUSINESS_PAYMENT: false,
  DIGITAL_TRAVEL_PAYMENT: false,
  BUSINESS_CARD: false,
};

export type ServicesDraft = {
  services: Partial<ApplicationPayload['servicesDetails']>;
  productMap?: ProductMap;
  additionalConfigurations?: CustomPricing;
  productMapTemp?: any; // Prop to store some temporary data
  isAgreeWithServicesTermsAndConditions: boolean;
};

interface Props {
  disabled?: boolean;
  hideServiceSelection?: boolean;
  hideDisabledServices?: boolean;
  reviewAndSubmit?: boolean;
}

const ServicesDetails: React.FC<any> = (props) => {
  const { reviewAndSubmit } = props;
  const [showConfirmResetModal, setShowConfirmResetModal] = useState<any>(false);
  const globeState = useSelector((state: any) => state?.state);
  const { confirmValue } = globeState;
  const dispatch = useDispatch();
  const ref = useRefScrollTo();
  const formName = 'servicesDetails';
  const [form] = Form.useForm<Draft<'servicesDetails'>>();
  const applicationQuery = useGetApplication();
  const { t } = useTranslation();
  const trueValue = true;
  const selectStepMutation = useSelectStep();
  const { defaultValue: sourceChannelDefault } = useHandbookDefault('sourceChannel');

  useEffect(() => {
    if (!reviewAndSubmit) {
      selectStepMutation.mutateAsync('services.servicesDetails');
    } else {
      selectStepMutation.mutateAsync('application.reviewAndSubmit');
    }
  }, []);

  const servicesQuery: any = useGetServices();
  const fieldMap = useFieldMap();
  const { isAmendment, lockedProductKeys } = useAmendment();
  const hasLockedProduct = isAmendment && lockedProductKeys.length > 0;

  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const servicesDetailsStep = stagePayload?.steps
    ?.find((step) => step.view === 'services')
    ?.steps?.find((step) => step.uiKey === 'servicesDetails');
  const isServicesDetailsUnsubmitted = servicesDetailsStep?.validationState === 'UNSUBMITTED';
  const servicesDetailsDraftQuery = useGetDraft<Draft<'servicesDetails'>>(
    servicesDetailsStep?.key ?? 'services.servicesDetails',
  );
  const hasServicesDetailsDraft = !!servicesDetailsDraftQuery.data?.servicesDetails?.products;
  const useInitialSelection = isServicesDetailsUnsubmitted && !hasServicesDetailsDraft;
  const initialProducts = applicationQuery?.data?.payload?.selectServices?.initialProducts;
  const findProduct = (list: any, productType: string) => list?.find((p: any) => p?.id === productType);

  const resolveProductEnabled = (productType: string, isLocked: boolean, savedEnabled?: boolean) => {
    if (isLocked) return true;
    if (useInitialSelection) {
      const initialEnabled = findProduct(initialProducts, productType)?.enabled;
      if (initialEnabled !== undefined) return !!initialEnabled;
    }
    return savedEnabled ?? !!findProduct(initialProducts, productType)?.enabled;
  };

  function parseBeforeSubmitHandler(values: any) {
    const preResult = values?.servicesDetails;
    const { levelsSelected, products, ...rest } = preResult;
    const sortedArrtoThisOrder = ['company', 'region', 'branch', 'department', 'cardholder'];
    const sortedProductLevelsSelect = sortedArrtoThisOrder?.filter((item: any) => levelsSelected?.includes(item));
    const finalProducts = products?.map((item: any) => {
      return { ...item, levelsSelected: sortedProductLevelsSelect };
    });
    const result = { servicesDetails: { ...rest, products: finalProducts, levelsSelected: sortedProductLevelsSelect } };
    return result;
  }

  const arrayToObjectByAttribute = (array: any) =>
    array?.reduce((obj: any, item: any) => {
      if (!obj[item?.tag]) {
        obj[item?.tag] = [item];
      } else {
        obj[item?.tag] = [...obj[item?.tag], item];
      }
      return obj;
    }, {});

  /// reselect products
  const selectedProducts = form.getFieldValue(['servicesDetails', 'products'])?.map((item: any) => {
    return { enabled: item?.enabled, id: item?.id, pct: item.pct };
  });

  useEffect(() => {
    if (selectedProducts?.length) {
      for (let i = 0; i < selectedProducts?.length; i++) {
        if (!selectedProducts[i]?.enabled) {
          form.setFieldValue(['servicesDetails', 'products', i, 'productPercentageBalance'], undefined);
          form.setFieldValue(['servicesDetails', 'products', i, 'cashbackRedemptionRebate'], undefined);
          form.setFieldValue(['servicesDetails', 'products', i, 'pct'], undefined);
        }
      }
    }
  }, [JSON.stringify(selectedProducts)]);

  // Validation
  const [isPanelError, setPanelError] = useState<any>(initialPanelErrorState);
  if (!applicationQuery.data) return null;
  if (!servicesQuery?.data) return null;
  if (!fieldMap) return null;
  //
  const hierarchWidgets = arrayToObjectByAttribute(servicesQuery?.data?.services[1]?.fields)?.HIERARCHY_LEVELS || [];
  const defaultLevels = hierarchWidgets
    ?.filter((element: any) => element?.value?.defaultValue?.checked)
    ?.map((item: any) => item?.key);
  // [];

  function beforeFinishHandler() {
    const response = true;
    if (isAmendment) {
      const productsFormValue = form.getFieldValue(['servicesDetails', 'products']) || [];
      const enabledProductsList = productsFormValue.filter((item: any) => item?.enabled);
      const hasNewProduct = enabledProductsList.some((item: any) => !lockedProductKeys.includes(item?.id));
      if (enabledProductsList.length && !hasNewProduct) {
        message.warning('Please select a new product before submitting.');
        return false;
      }
    }
    const levelsSelectedFormValue = form.getFieldsValue()?.servicesDetails?.levelsSelected;
    const sortedArrtoThisOrder = ['company', 'region', 'branch', 'department', 'cardholder'];
    const sortedProductLevelsSelect = sortedArrtoThisOrder?.filter((item: any) =>
      levelsSelectedFormValue?.includes(item),
    );
    if (!applicationQuery?.data?.payload?.servicesDetails?.levelsSelected) {
      return true;
    }
    if (confirmValue) {
      return true;
    }
    if (
      JSON.stringify(sortedProductLevelsSelect) !==
      JSON.stringify(applicationQuery?.data?.payload?.servicesDetails?.levelsSelected)
    ) {
      setShowConfirmResetModal(true);
      return false;
    }
    return response;
  }
  const enabledProducts = applicationQuery?.data?.payload?.selectServices?.initialProducts;
  const checkedPrducts = enabledProducts?.filter((ele: any) => ele.enabled);
  const checkIfCorporativeOnlySelected =
    checkedPrducts?.length > 1 ? false : !!checkedPrducts?.find((item: any) => item.id === 'CORPORATE_EXECUTIVE_CARD');

  return (
    <Container ref={ref}>
      <Form<Draft<'servicesDetails'>>
        disabled={reviewAndSubmit}
        form={form}
        parseBeforeSubmit={parseBeforeSubmitHandler}
        stepKey="servicesDetails"
        name={formName}
        setInitialValues={(initialValues: any) => {
          const savedProducts = initialValues?.servicesDetails?.products;
          const products = (servicesQuery?.data?.services || []).map((service: any, index: number) => {
            const saved = findProduct(savedProducts, service?.type) ?? savedProducts?.[index];
            const isLocked = isAmendment && lockedProductKeys.includes(service?.type);
            return {
              ...(saved || {}),
              id: service?.type,
              enabled: resolveProductEnabled(service?.type, isLocked, saved?.enabled),
            };
          });
          const currentSourceChannel = initialValues?.servicesDetails?.sourceChannel;
          return {
            ...initialValues,
            servicesDetails: {
              ...(initialValues?.servicesDetails || {}),
              products,
              sourceChannel: currentSourceChannel ?? sourceChannelDefault,
            },
          };
        }}
        onBeforeSubmit={() => beforeFinishHandler()}
        onValuesChange={(changedValues) => {
          const annualExpectedValue = form.getFieldValue(['servicesDetails', 'expectedAnnualTransaction']);
          const stringifiedValue = String(annualExpectedValue);
          if (stringifiedValue.includes('.')) {
            const splitedValue = stringifiedValue.split('.');
            if (splitedValue[0]?.length > 16) {
              form.setFieldValue(
                ['servicesDetails', 'expectedAnnualTransaction'],
                `${splitedValue}.${splitedValue[1]}`,
              );
            }
          } else {
            if (stringifiedValue?.length > 16) {
              form.setFieldValue(
                ['servicesDetails', 'expectedAnnualTransaction'],
                `${stringifiedValue.substring(0, 16)}.00`,
              );
            }
          }
          const changedProduct = get(changedValues?.servicesDetails, 'products');
          const isPct = find(changedProduct, 'pct');
          if (changedProduct?.length && isPct) {
            const index = Object.keys(changedProduct)[0];
            form.setFieldValue(['servicesDetails', 'products', index, 'cashbackRedemptionRebate'], undefined);
          }
        }}
      >
        {!reviewAndSubmit && (
          <div className="sectionHeader">
            <Typography.Title level={1}>{t('Product Solutions')}</Typography.Title>
            <Typography.Paragraph className="SelectServicesInitial-Paragraph">
              {t('View the Fee Schedule for the different services offered for the solution(s) selected')}
            </Typography.Paragraph>
          </div>
        )}
        {showConfirmResetModal && formName === 'servicesDetails' && (
          <Alert
            className="AlertReset"
            description={
              <div style={{ marginBottom: '50px' }}>
                As you have made changes in the hierarchy levels, your previous data & selection would be deleted.
              </div>
            }
            type="info"
            action={
              <Space direction="vertical">
                <Button
                  htmlType="button"
                  style={{ position: 'absolute', width: '70px', bottom: 10, left: 30 }}
                  size="small"
                  type="primary"
                  onClick={() => {
                    dispatch(setConfirmValue<any>(true));
                    setShowConfirmResetModal(false);
                    form.submit();
                  }}
                >
                  Accept
                </Button>
                <Button
                  style={{ position: 'absolute', width: '70px', bottom: 10, right: 30 }}
                  size="small"
                  danger
                  type="ghost"
                  onClick={() => {
                    dispatch(setConfirmValue<any>(false));
                    setShowConfirmResetModal(false);
                  }}
                >
                  Decline
                </Button>
              </Space>
            }
          />
        )}
        <Space className="ServicesForm-Space" size={20}>
          <div className="productsCardsParent">
            {servicesQuery?.data?.services?.map((item: any, index: number) => {
              const itemKey = item.type;
              const isProductLocked = isAmendment && lockedProductKeys.includes(item.type);
              return (
                <CardChildContainer key={item?.type} type={item?.type}>
                  <Space key={item?.key} size={16} direction="vertical">
                    <>
                      <Form.Item valuePropName="checked" name={n(['products', index, 'enabled'])} noStyle>
                        <ServiceCheckbox
                          inputKey={item?.key}
                          name={item?.name}
                          header={item?.name}
                          disabled={isProductLocked}
                        />
                      </Form.Item>
                      <Form.Item valuePropName="id" name={n(['products', index, 'id'])} noStyle>
                        <Input style={{ display: 'none' }} />
                      </Form.Item>
                    </>
                  </Space>
                </CardChildContainer>
              );
            })}
          </div>
        </Space>
        <div>
          <>
            <Row gutter={12}>
              <Col>
                <Typography.Title level={5}>{t('Hierarchy Levels')} </Typography.Title>
              </Col>
              <Col>
                <Hint
                  text={t(
                    'First & last hierarchy are mandatory, the other 3 needs to be selected as per your requirement.',
                  )}
                />
              </Col>
            </Row>
            {hierarchWidgets?.length && defaultLevels && (
              <Form.Item name={n(['levelsSelected'])} initialValue={defaultLevels}>
                <Checkbox.Group>
                  <Space direction="vertical">
                    {hierarchWidgets?.map((ele: any) => (
                      <HierarchyCheckBox
                        disabled={!ele?.editable?.merchant || hasLockedProduct}
                        key={ele?.key}
                        name={ele?.key}
                        header={ele?.key}
                        value={ele?.key}
                      />
                    ))}
                  </Space>
                </Checkbox.Group>
              </Form.Item>
            )}
          </>
        </div>
        <div>
          <Row justify="center" align="middle">
            <Col span={12}>
              <Typography.Title level={5}>
                {capitalizeWords(t('Do you require virtual card integration via API’s ?'))}
              </Typography.Title>
            </Col>
            <Col span={12}>
              <Form.Item
                disabled={checkIfCorporativeOnlySelected || hasLockedProduct}
                initialValue={checkIfCorporativeOnlySelected ? false : undefined}
                // rules={[{ required: true }]}
                name={n(['isVirtualCardApi'])}
              >
                <Radio.Group>
                  <Radio value={trueValue}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div>
          <Col span={12}>
            <Typography.Title level={5}>
              {capitalizeWords(t('Expected annual card transaction value (AED)'))}
            </Typography.Title>
            <Form.Item
              disabled={hasLockedProduct}
              rules={[
                {
                  message: 'Value must be greater than or equal to 0',
                  validator: (_, value) => {
                    if (!/^[+]?\d+([.]\d+)?$/.test(value)) {
                      return Promise.reject();
                    }
                    return Promise.resolve();
                  },
                },
              ]}
              name={n(['expectedAnnualTransaction'])}
            >
              <InputNumber stringMode precision={2} type="number" disabled={hasLockedProduct} />
            </Form.Item>
          </Col>
        </div>
        <div>
          <Col span={12}>
            <Typography.Title level={5}>{capitalizeWords(t('Source Channel'))}</Typography.Title>
            <Form.Item disabled={hasLockedProduct} name={n(['sourceChannel'])}>
              <DropDown
                key="sourceChannel"
                dropDownKey="sourceChannel"
                itemKey="sourceChannel"
                disabled={hasLockedProduct}
              />
            </Form.Item>
          </Col>
        </div>
        <div className="productsParents">
          {servicesQuery?.data?.services?.map((item: any, index: number) => {
            const seperatedWidgetsOnTagsObject = arrayToObjectByAttribute(item?.fields);
            const isProductLockedForFields = isAmendment && lockedProductKeys.includes(item.key);
            const isProductLocked = isAmendment && lockedProductKeys.includes(item.type);
            const content = (
              <>
                <LongDescription longDescription={item?.shortDescription} />
                <DynamicForm
                  formName={formName}
                  widgets={seperatedWidgetsOnTagsObject}
                  index={index}
                  parentKey={item?.type}
                  selectedProducts={selectedProducts}
                  productLocked={isProductLockedForFields}
                />
              </>
            );
            return (
              <>
                <ProductChildContainer type={item?.type}>
                  <Collapse ghost className="ServicesForm-Collapse" defaultActiveKey={[item.key]}>
                    <Collapse.Panel
                      key={item.key}
                      header={item.name}
                      collapsible={
                        !isProductLocked && selectedProducts?.find((ele: any) => ele?.id === item?.type)?.enabled
                          ? 'header'
                          : 'disabled'
                      }
                      error={isPanelError[item?.key]}
                    >
                      {selectedProducts?.find((ele: any) => ele?.id === item?.type)?.enabled ? content : <></>}
                    </Collapse.Panel>
                  </Collapse>
                </ProductChildContainer>
              </>
            );
          })}
        </div>
      </Form>
    </Container>
  );
};
const n = buildNamePath('servicesDetails');
const Container = styled.div`
  .AlertReset {
    position: fixed;
    right: 70px;
    width: 250px;
    bottom: 130px;
    z-index: 20;
  }
  .productsCardsParent {
    display: flex;
    flex-direction: row;
  }
  .productsParents {
    display: flex;
    flex-direction: column;
  }
  .ServicesForm-Space {
    flex-wrap: wrap;
    position: sticky;
    top: 0;
    background-color: ${colors.componentBackground};
    z-index: 3;
    margin-bottom: 40px;
    align-items: flex-start;
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0px 2px 2px 1px ${colors.componentBackground};
    .ant-space-item {
      display: flex;
      flex: 1;
      height: 100%;
    }
  }
  .ServicesForm-Title {
    margin-top: 0 !important;
    margin-bottom: 16px;
  }
  .ServicesForm-CardMobile {
    margin-bottom: 24px;
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    .ServicesForm-LongDescription {
      margin-bottom: 0;
    }
  }
`;
const ProductChildContainer = styled.div<any>`
  order: ${({ type }) => {
    if (type === 'BUSINESS_CARD') {
      return 1;
    }
    if (type === 'CORPORATE_EXECUTIVE_CARD') {
      return 2;
    }
    if (type === 'DIGITAL_BUSINESS_PAYMENT') {
      return 3;
    }
    if (type === 'DIGITAL_TRAVEL_PAYMENT') {
      return 4;
    }
    return 0;
  }};
  border: solid 1px #e2e2e3;
  border-radius: 10px;
  padding: 16px;
  margin-top: 48px;
  .Collapse-Icon {
    vertical-align: 2.5px !important;
  }
  .ant-collapse-header {
    font-size: 24px;
    /* padding: 16px 0; */
    text-transform: unset;
  }
  .ant-collapse-content-box {
    /* padding: 0 0 40px 0 !important; */
  }
`;
const CardChildContainer = styled.div<any>`
  margin-right: 8px;
  order: ${({ type }) => {
    if (type === 'BUSINESS_CARD') {
      return 1;
    }
    if (type === 'CORPORATE_EXECUTIVE_CARD') {
      return 2;
    }
    if (type === 'DIGITAL_BUSINESS_PAYMENT') {
      return 3;
    }
    if (type === 'DIGITAL_TRAVEL_PAYMENT') {
      return 4;
    }
    return 0;
  }};
`;

export default ServicesDetails;
